// extracted by mini-css-extract-plugin
export default {"ConsolidatedShippingFormFields":"consolidated-shipping-form-fields__ConsolidatedShippingFormFields__xyQbI"};